import React, { useState } from 'react';
import { Button, Header, Input } from '../../components';
import Loading from '../../components/Loading';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../../contexts/ContextProvider';
import Select from 'react-select';
import axiosClient from '../../axios-client';
import Alert from '../../components/Alert';
import { toast } from 'react-toastify';
import { TbMath } from 'react-icons/tb';
import MySelect from '../../components/MySelect';
import { GrWorkshop } from 'react-icons/gr';

const AddEnseignant = ({ onClose }) => {
    const [loading, setLoading] = useState(false);


    const navigate = useNavigate();

    const [errors, setErrors] = useState([]);
    const { token, setToken } = useStateContext()
    const [enseignant, setEnseignant] = useState({
        tel: '',
        nom: '',
        nni: '',
        adresse: '',
        montantHours: 0,
        password: '',
        password_confirmation: ''
    })

    const onSubmit = () => {
        setErrors([]);
        setLoading(true);
        axiosClient.post('/enseignant', enseignant)
            .then((response) => {
                setLoading(false);
                setErrors(null);
                onClose();
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }

    return (
        <>
            <div className=' fixed inset-0 h-full bg-black bg-opacity-25 backdrop-blur-sm  '>
                <div className='h-screen flex justify-center items-center'>
                    <div className='flex-col max-h-screen  overflow-auto bg-white lg:p-10 xl:p-10  p-2 md:p-10 w-auto rounded-xl'>
                        <div className=''>
                            <Header icon={<GrWorkshop />} title="Ajouter un Enseignant" titleAr={"إضافة مدرّس"} />
                        </div>
                        {errors &&
                            Object.keys(errors).map(key => (
                                <Alert key={key} message={errors[key][0]} />
                            ))
                        }
                        <div className='flex-col  justify-evenly '>
                            <div className='mr-2 flex gap-2'>
                                <Input label="Telephone (username)" labelAr={" اسم المستخدم (رقم الهاتف)"} type="text" value={enseignant.tel} onChange={ev => setEnseignant({ ...enseignant, tel: ev.target.value })} required="required" />
                                <Input label="Nom" labelAr={"الإسم الكامل"} type="text" value={enseignant.nom} onChange={ev => setEnseignant({ ...enseignant, nom: ev.target.value })} required="required" />
                            </div>
                            <div className='mr-2'>
                                <Input label="Montant / heure" labelAr="المبلغ / الساعة" type="text" value={enseignant.montantHours} onChange={ev => setEnseignant({ ...enseignant, montantHours: ev.target.value })} required="required" />
                            </div>
                            <div className='mr-2 flex gap-2'>
                                <Input label="NNI" labelAr={"الرقم الوطني"} type="text" value={enseignant.nni} onChange={ev => setEnseignant({ ...enseignant, nni: ev.target.value })} />
                                <Input label="Adresse" labelAr={"العنوان"} type="text" value={enseignant.adresse} onChange={ev => setEnseignant({ ...enseignant, adresse: ev.target.value })} />
                            </div>
                            <div className='mr-2'>
                                <Input label="Mots de passe" labelAr={"كلمة المرور"} type="password" value={enseignant.password} onChange={ev => setEnseignant({ ...enseignant, password: ev.target.value })} required="required" />
                            </div>
                            <div className='mr-2'>
                                <Input label="Confirmater le mots de passe" labelAr={"تحقق من كلمة المرور"} type="password" value={enseignant.password_confirmation} onChange={ev => setEnseignant({ ...enseignant, password_confirmation: ev.target.value })} required="required" />
                            </div>
                        </div>
                        <div className='flex justify-end items-end'>
                            <div className=' m-4 w-70 justify-between'>
                                {loading ? <Loading />
                                    :
                                    <Button onClick={onSubmit} color="ml-1 bg-green-500" textColor="text-white" text="Enregistrer" />
                                }
                                <Button onClick={() => onClose()} color="bg-red-500" textColor="text-white" text="Annuler" />
                                
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>

    )
}

export default AddEnseignant